import React from "react";
import styled from "@emotion/styled";
import { ThemeContext } from "../contexts/Context";


const MenuItemDisplay3 = ({
    item,
    lanIndex,
    isLanReverse,
    currencySymbol,
    selectedItems,
    setSelectedMenu,
    menuSelectionFormRef,
    recentBoughtCard = false
}) => {

    const themeContext = React.useContext(ThemeContext);

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        menuSelectionFormRef.current = JSON.parse(JSON.stringify(item));
        setSelectedMenu(JSON.parse(JSON.stringify(item)));
    };

    return (
        <ItemWrapper onClick={handleClick} themeContext={themeContext} recentBoughtCard={recentBoughtCard}>
            <ItemDisplay
                image={item.image}
                themeContext={themeContext}
                recentBoughtCard={recentBoughtCard}
            ></ItemDisplay>
            <OptionsDisplay themeContext={themeContext} recentBoughtCard={recentBoughtCard}>
                <MenuInfoHeaderContainer>
                    <TitleContainer
                        themeContext={themeContext}
                    >{`${(lanIndex === 0 && !isLanReverse) || (lanIndex === 1 && isLanReverse) ? item.title : item.title2 ? item.title2 : item.title}`}</TitleContainer>

                </MenuInfoHeaderContainer>
                <PriceField>
                    {currencySymbol}&nbsp;{item.price.toFixed(2)}
                </PriceField>
                {/* Quantity Component */}
                {selectedItems[item.codeId] && selectedItems[item.codeId] > 0 &&
                    <ItemQty themeContext={themeContext}>x{selectedItems[item.codeId]}</ItemQty>
                }

            </OptionsDisplay>
        </ItemWrapper>
    );


};

export default MenuItemDisplay3;

const ItemWrapper = styled.div`
  position: relative;
  display: flex;
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 8px;
  padding: 8px;
  border-radius: 8px;
  min-width: 60%;
  width: 60%;
  color: ${(props) => props.themeContext.fontSecondary};
  background-color:${(props) =>  props.themeContext.optionHeaderBackgroundColor};
  box-shadow: 1px 1px 2px rgba(0,0,0,0.7);

  @media (min-width: 768px) {
    ${(props) => props.recentBoughtCard ? `
      min-width: 0;
      width: 100%;
      min-height: 112px;
      margin: 0;
      padding: 12px;
      box-sizing: border-box;
      align-items: center;
      border: 1px solid ${props.themeContext.borderColor || "rgba(15, 23, 42, 0.1)"};
      border-radius: 16px;
      box-shadow: 0 7px 22px rgba(15, 23, 42, 0.12);
      cursor: pointer;
      transition: transform 160ms ease, box-shadow 160ms ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
      }
    ` : ""}
  }
`;

const ItemQty = styled.div`
  position: absolute;
  font-size: 12px;
  background-color: ${(props) => props.themeContext.fontSecondary};
  color: ${(props) => props.themeContext.primaryColor}; 
  bottom: 8px;
  right: 8px;
  border-radius: 13px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 3px rgba(0,0,0,0.65); 
`;

const ItemDisplay = styled.div`
  display: block;
  text-align: center;
  justify-content: center;
  align-items: center;
  height:  60px;
  width: 60px;
  background-image: url(${(props) => props.image});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  @media (min-width: 768px) {
    ${(props) => props.recentBoughtCard ? `
      flex: 0 0 88px;
      width: 88px;
      height: 88px;
      border-radius: 12px;
      box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.06);
    ` : ""}
  }
`;

const OptionsDisplay = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 6px;

  font-family: ${(props) => props.themeContext.fontFamily};
  text-align: left;
  font-size: 14px;
  width: calc(100% - 60px);

  @media (min-width: 768px) {
    ${(props) => props.recentBoughtCard ? `
      min-width: 0;
      width: calc(100% - 88px);
      padding-left: 14px;
      box-sizing: border-box;
      font-size: 15px;
      line-height: 1.35;
    ` : ""}
  }
`;

const MenuInfoHeaderContainer = styled.div`
  display: -webkit-box;
  flex-grow:1;
  -webkit-line-clamp: 2;
  word-wrap:break-word;
  -webkit-box-orient: vertical;
  overflow:hidden;
`;

const TitleContainer = styled.div`
  display: block;
  font-weight: 600;

`;

const PriceField = styled.div`
  display: block;
`;
